import { render, staticRenderFns } from "./_addResellerClientModal.vue?vue&type=template&id=71db2830"
import script from "./_addResellerClientModal.vue?vue&type=script&lang=js"
export * from "./_addResellerClientModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports